export default __webpack_public_path__ + "static/media/pressure using nhexane 1000RPM 0.75mol fueltot.85438243.png";